// Copyright (c) 2017 Deere & Company

import Accordion from '../../../shared/components/smart-accordion/state/accordion';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const toggleAccordion = state =>
    Accordion.update(state, {
        isExpanded: {
            $set: !state.isExpanded
        }
    });

export default (state = getDefaultState().reportsAccordion, action) => {

    const actionTypes = {
        [actions.TOGGLE_OPEN_PIP_REPORTS_ACCORDION]: toggleAccordion
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/open-pips/reducers/reports-accordion.js